import { render } from "./helpCheckoutSubMaterial.vue?vue&type=template&id=f08e0200"
import script from "./helpCheckoutSubMaterial.vue?vue&type=script&lang=js"
export * from "./helpCheckoutSubMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__